import Immutable from 'immutable';
import * as actionTypes from '../actionTypes/clientCodeActionTypes';
import { createReducer } from '../utils';

const initialState = Immutable.fromJS({
  clientCodeList: [],
  hasMadeRequest: false, // for spinner
  loadedPrevClientCodeList: false, // first time loaded
  errorMessage: null,
  sessionClientCode: '',
});

export default createReducer(initialState, {
  [actionTypes.CLIENT_CODE_LIST.SUCCESS]: (state, action) => {
    const { resBody } = action;
    const newState = { ...state, hasMadeRequest: false, loadedPrevClientCodeList: true };

    // For ajax search do not update if list empty
    if (resBody.length > 0) newState.clientCodeList = resBody;
    return state.merge(newState);
  },
  [actionTypes.CLIENT_CODE_SET.SUCCESS]: (state, action) =>
    state.merge({
      sessionClientCode: action.code,
      hasMadeRequest: false,
    }),

  [actionTypes.CLIENT_CODE_LIST.REQUEST]: state =>
    state.merge({
      hasMadeRequest: true,
    }),

  [actionTypes.CLIENT_CODE_SET.REQUEST]: state =>
    state.merge({
      hasMadeRequest: true,
    }),

  [actionTypes.CLIENT_CODE_LIST.ERROR]: state =>
    state.merge({
      hasMadeRequest: false,
    }),

  [actionTypes.CLIENT_CODE_SET.ERROR]: state =>
    state.merge({
      hasMadeRequest: false,
    }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/clientCodeReducer.js